export default __webpack_public_path__ + "static/media/Liliane.e168ad67.png";